// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetBuilderSuggestsRequest,
  TGetBuilderSuggestsModel,
  IMappers,
  TGetBuilderSuggestsResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetBuilderSuggestsResponseSchema } from '../../entities/schemas/GetBuilderSuggestsResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetBuilderSuggestsModel(parameters: IGetBuilderSuggestsRequest): TGetBuilderSuggestsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'countryside-search',
    pathApi: '/v1/get-builder-suggests/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetBuilderSuggestsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetBuilderSuggestsRequest;
}

export async function fetchGetBuilderSuggests<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetBuilderSuggestsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetBuilderSuggestsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetBuilderSuggestsModel(parameters),
    config,
  )) as FetchResponse<TGetBuilderSuggestsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetBuilderSuggestsResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetBuilderSuggestsResponse>;
}
